export function _className(condition, name = '') {
  if (condition) return name;
  return '';
}
